import React from "react";
import { object, string } from "prop-types";

import ComponentContainer from "../../../layouts/component-container";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import NewsHeadline from "../../../atoms/NewsHeadline";

import { getStoriesFromCollection, trim } from "../../../utils/utils";

import "./special-event.m.css";

const SpecialEvent = ({ collection, className = "" }) => {
  collection = collection?.items?.find(({ type }) => type === "collection");

  if (!(collection && collection.items && collection.items.length)) return null;

  let { theme } = collection["associated-metadata"] || {};

  const stories = getStoriesFromCollection(collection);

  const [first, second, ...thirdToFifth] = stories.slice(0, 5);

  theme = trim(theme, "green");

  return (
    <ComponentContainer
      titleClass="title"
      collection={collection}
      styleName="base"
      isDesktopBanner={true}
      isBanner={true}
      className={`${theme} ${className}`}
    >
      <div styleName="container">
        <div styleName="first-column">
          <LeftImageRightNews story={first} showExcerpt={false} imageType="image1x1" aspectRatio={[1, 1]} />
          <div styleName="second-story">
            <NewsHeadline story={second} />
          </div>
        </div>
        <div styleName="right-stories">
          {thirdToFifth.map((story, i) => (
            <NewsHeadline story={story} key={i} />
          ))}
        </div>
      </div>
    </ComponentContainer>
  );
};

SpecialEvent.propTypes = {
  collection: object,
  className: string,
};

export default SpecialEvent;
